import React from 'react';
import ReactTooltip from 'react-tooltip';

interface TooltipProps {
  type?: 'light';
  v2?: boolean;
  id?: string;
  bindHtml?: boolean;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

const Tooltip = ({ type, v2, placement, id, bindHtml }: TooltipProps) => {
  return (
    <ReactTooltip
      effect="solid"
      type={type}
      multiline
      html={bindHtml}
      id={id}
      className={v2 ? 'custom-tooltip' : ''}
      place={placement}
    />
  );
};

export default Tooltip;
